import { render, staticRenderFns } from "./Domiciliar.vue?vue&type=template&id=488ac9de&scoped=true"
import script from "./Domiciliar.vue?vue&type=script&lang=js"
export * from "./Domiciliar.vue?vue&type=script&lang=js"
import style0 from "./Domiciliar.vue?vue&type=style&index=0&id=488ac9de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488ac9de",
  null
  
)

export default component.exports